<template>
  <div class="pt-50 pl-26 flex slide">
    <div
      class="slide-content flex flex-col-reverse h-max"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >

      <div class="left flex mt-12.5">
        <div class="relative h-37.5 mr-[2.875rem]">
          <div
            v-for="(item, index) in projectsText.projects"
            :key="item + index"
            class="absolute left-0"
          >
            <transition name="slide">
              <p
                v-if="index === currentSlide"
                class="uppercase fz-10 font-medium"
                style="color: rgba(151, 163, 203, 0.6)"
              >
                0{{ currentSlide + 1 }}
              </p>
            </transition>
          </div>
        </div>
        <div class="relative w-87.5 flex hover">
          <transition-group name="text">
            <div
              class="text w-87.5 mr-12.5 absolute"
              v-for="(item, index) in projectsText.projects"
              v-show="index === currentSlide"
              :key="item.name + index"
            >
              <h4
                class="company-name fz-32 font-normal mb-5"
                style="color: rgba(255, 46, 83, 1)"
              >
                {{ item.name }}
              </h4>
              <p class="company-description font-medium fz-16">
                {{ item.description }}
              </p>
            </div>
          </transition-group>

        </div>
        <div class="relative w-30 ml-auto">
          <img
            src="@/assets/images/eye-circle.svg"
            @click="setProject(projectsText.projects[currentSlide].id)"
            class="w-12 h-12 links absolute left-0 z-20 cursor-pointer"
            alt=""
          />
          <img
            @click="$emit('nextSlide')"
            src="@/assets/images/arrow-down-circle.svg"
            class="w-12 h-12 links absolute right-0 cursor-pointer"
            alt=""
          />
        </div>
      </div>
      <div class="right h-[25rem] w-145 relative overflow-hidden">
        <div
          class="absolute work left-0"
          v-for="(item, index) in projectsText.projects"
          :key="item.name + index"
        >
          <div class="relative h-[25rem] w-145">
            <transition name="image">
              <img
                class="h-[25rem] w-145 absolute work left-0"
                :class="{ hover: hover }"
                v-if="index === currentSlide"
                :src="require('@/assets/images/projects/' + item.id + '/' + item.preview + '.png')"
                alt=""
              />
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "projectsSlide2",
  emits:['nextSlide'],
  props: {
    currentSlide: {
      type: Number,
      default() {
        return 0;
      },
    }
  },
  data() {
    return {
      hover: false,
    };
  },
  methods:{
    ...mapMutations(['setProject'])
  },
  computed: {
    text() {
      return require("@/assets/text/projects/slide2/" + this.lang + ".json");
    },
    projectsText(){
      return require("@/assets/text/project/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },

};
</script>

<style scoped>
.text-enter-active,
.text-leave-active,
.slide-enter-active,
.slide-leave-active {
  transition: all linear 0.5s;
  top: 0;
}
.text-enter-from {
  top: 80%;
  opacity: 0;
}
.text-leave-to {
  top: -80%;
  opacity: 0;
}
.slide-enter-from {
  opacity: 0;
}
.slide-leave-to {
  opacity: 0;
}

.links {
  transition: all linear 0.2s;
}
.work {
  transition: all linear 0.2s;
  transform: translateX(0) scale(1);
}
.work.hover {
  transform: scale(1.1);
}

.image-leave-active,
.image-enter-active {
  transition: all linear 0.5s;
}

.image-enter-from {
  left: 100%;
}
.image-leave-to {
  left: -100%;
}
</style>
